"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.save = exports.get = exports.exchange = exports.clear = void 0;
var cookies = _interopRequireWildcard(require("@kiwicom/cookies"));
var utils = _interopRequireWildcard(require("./utils"));
var _utils2 = require("../utils");
var skyusersApi = _interopRequireWildcard(require("../skyusersApi"));
var web = _interopRequireWildcard(require("./web"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const get = () => {
  const accessToken = cookies.load(cookies.Cookie.UA_SESSION_TOKEN);
  const tokenData = utils.emptyTokenData("legacy");
  if (accessToken !== null) {
    tokenData.accessToken.data = accessToken;
  }
  return tokenData;
};
exports.get = get;
const save = tokenData => {
  if (tokenData.accessToken.data !== null) {
    cookies.save(cookies.Cookie.UA_SESSION_TOKEN, tokenData.accessToken.data);
  }
};
exports.save = save;
const clear = () => {
  cookies.remove(cookies.Cookie.UA_SESSION_TOKEN);
};
exports.clear = clear;
const exchange = async tokenData => {
  try {
    if (tokenData.accessToken.isLegacy && tokenData.accessToken.data !== null) {
      const response = await skyusersApi.refreshToken(tokenData.accessToken.data);
      if (response !== null) {
        const newTokenData = utils.processTokens(response.accessToken, response.refreshToken);
        web.save(newTokenData);
        clear();
        return newTokenData;
      }
    }
    return utils.emptyTokenData();
  } catch (error) {
    (0, _utils2.log)("Failed to exchange legacy token:", error);
    throw error;
  }
};
exports.exchange = exchange;